module.exports = __webpack_public_path__ + "img/resource.beb1dd3d.svg";